import React from 'react';

export default function WithoutCycles() {
  return (
    <div className="text-center p-5">
      <p>
        You do not have enrollment cycles
      </p>
    </div>
  );
}
